import { render, staticRenderFns } from "./RelateUmaDuvida.vue?vue&type=template&id=561b3438&scoped=true&"
import script from "./RelateUmaDuvida.vue?vue&type=script&lang=js&"
export * from "./RelateUmaDuvida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561b3438",
  null
  
)

export default component.exports